<div class="row">
  <div class="col-xs-12" col-md-8>
    <alertbox [messageBox]="messageCabecera" [typeException]="typeException" [messageComplet]="messageComplet"></alertbox>
    <div *ngIf="userExist == true" class="row">
      <section class="col-xs-12 scyr-section-avisos" id="avisosAccordion">
        <section class="scyr-avisos">
          <div class="warn yellow box fade">
            <img src="assets/images/icons/averias.svg" class="untilMobileLandscape" alt="" />
            <div class="scy-avisos__texto">
              <div class="collapsible-header">
                <a aria-controls="exampleAccordion2"><h2><span class="title">El usuario existe</span></h2></a>
              </div>
              <div class="collapsible-body collapse" id="avisosAccordion2" role="tabpanel">
                <p>{{messageComplet}}</p>
                <div class="onlyMobileLandscape scy-avisos__texto_close">
                  <a href="#" id="close-yellow">Cerrar aviso</a>
                </div>
              </div>
            </div>
            <button (click)="userExist=false" type="button" class="close close-aviso untilMobileLandscape" id="close-yellow2">
              <img src="assets/images/icons/cross-blue.svg" alt="" />
              <span class="sr-only">Cerrar aviso</span>
            </button>
            <div class="input-form input-button">
              <button type="submit" class="btn-default" (click)="ActualizarUser()" value="">Registrar</button>
            </div>
          </div>
        </section>
      </section>
    </div>
    <section>
      <div class="contact-title-area">
        <h1>Registro</h1>
        <div class="tlf-contacto btn-default tlf-contacto__desktop">
          <p>Llámenos para cualquier consulta</p>
          <p class="tlf">
            <img src="assets/images/icons/llamanos-blue.svg" alt="">
            <span>{{telefonoexplotacion}}</span>
          </p>
        </div>
        <a href="tel:{{telefonoexplotacion}}" class="btn-default tlf-contacto__mobile">{{telefonoexplotacion}}</a>
      </div>
      <p>Rellenando el siguiente formulario recibirá a través de correo electrónico su clave de acceso, con la cual podrá acceder a datos sobre su facturación, consumos, etc...</p>
      <div class="col-xs-12 box">
        <form class="" #userForm="ngForm" id="Userform" method="get" action="">
          <h2 class="line">Datos del usuario</h2>
          <fieldset>
            <legend class="sr-only">Formulario datos solicitante</legend>
            <div class="row">
              <div class="col-xs-12 col-sm-6 col-md-6">
                <div class="input-form input-select">
                  <label for="poblacion" class="slct">Población</label>
                  <div class="select">
                    <select name="poblacion" (change)="cargarDatos()" [(ngModel)]="poblacion">
                      <option *ngIf="explotaciones.length !== 1" value="-1" selected>Seleccione una población</option>
                      <option *ngFor="let explotacion of explotaciones; let i = index" value={{i}}>{{explotacion.Descripcion}}</option>
                    </select>
                  </div>
                </div>
                <span *ngIf="poblacionInputError" class="error">Introduzca una población</span>
              </div>
              <div class="col-xs-12 col-sm-6 col-md-3">
                <div class="input-form input-text">
                    <input type="text" [(ngModel)]="dni" name="dni" value="" required />
                    <span class="highlight"></span>
                    <span class="bar"></span>
                    <label for="dni">DNI</label>
                </div>
                <span *ngIf="dniInputError" class="error">Introduzca un DNI válido</span>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 col-sm-6 col-md-6">
                  <div class="input-form input-text">
                      <input type="text" [(ngModel)]="nombreApellidos" name="nombreApellidos" value="" required />
                      <span class="highlight"></span>
                      <span class="bar"></span>
                      <label for="nombreApellidos">Nombre y Apellidos</label>
                  </div>
                  <span *ngIf="nombreApellidosInputError" class="error">Introduzca nombre y apellidos</span>
              </div>
              <div class="col-xs-12 col-sm-6 col-md-3">
                  <div class="input-form input-text">
                      <input type="text" [(ngModel)]="contrato" name="contrato" value="" required />
                      <span class="highlight"></span>
                      <span class="bar"></span>
                      <label for="contrato">Nº Contrato</label>
                  </div>
                  <span *ngIf="contratoInputError" class="error">Introduzca un número de contrato válido</span>
              </div>
            </div>

            <div class="row" *ngIf="!isEmmasa">
              <div class="col-xs-12 col-sm-6 col-md-6">
                <sacyr-input [setType]="'text'" [setName]="'factura'"
                  [setLabel]="'Nº última factura (sin espacios en blanco)'" [setValue]="factura" [setRequired]="true"
                  [setError]="facturaInputError ? 'Introduzca un nº de factura' : ''"
                  (outValue)="factura = $event"></sacyr-input>
              </div>

              <div class="col-xs-12 col-sm-6 col-md-3">
                <sacyr-input [setType]="'decimal'" [setName]="'importeFactura'" [setLabel]="'Importe última factura'"
                  [setValue]="importe" [setRequired]="true"
                  [setError]="importeInputError ? 'Introduzca un importe válido' : ''" (change)='cambiar()'
                  (outValue)="importe = $event"></sacyr-input>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 col-sm-6 col-md-6">
                  <div class="input-form input-text">
                      <input type="text" [(ngModel)]="email" name="email" value="" required />
                      <span class="highlight"></span>
                      <span class="bar"></span>
                      <label for="email">Email</label>
                  </div>
                  <span *ngIf="emailInputError" class="error">Introduzca un email válido</span>
              </div>
              <div class="col-xs-12 col-sm-6 col-md-3">
                  <div class="input-form input-text">
                      <input type="tel" [(ngModel)]="telefono" name="telefono" value="" required/>
                      <span class="highlight"></span>
                      <span class="bar"></span>
                      <label for="telefono">Teléfono1</label>
                  </div>
                  <span *ngIf="telefono1InputError" class="error">Introduzca un teléfono válido</span>
              </div>
              <div class="col-xs-12 col-sm-6 col-md-3">
                  <div class="input-form input-text">
                      <input type="tel" [(ngModel)]="telefono2" name="telefono2" value="" />
                      <span class="highlight"></span>
                      <span class="bar"></span>
                      <label for="telefono2">Teléfono2</label>
                  </div>
                  <span *ngIf="telefono2InputError" class="error">Introduzca un teléfono válido</span>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 col-sm-12 col-md-12">
                <br />
                <label for="consulta">{{avisoEmail}}</label>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 col-sm-12 col-md-6">
                <div class="input-form input-check">
                  <input type="checkbox" [(ngModel)]="Efactura" id="agree2" name="agree2" />
                  <label for="agree2"> Suscripción a factura electrónica </label>
                </div>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-6">
                <re-captcha #captchaRef="reCaptcha" [(ngModel)]="formModel.captcha" name="captcha" siteKey="{{keyCapchasite}}" #captchaControl="ngModel" required ></re-captcha>
                <span *ngIf="captchaError == true" class="error">Captcha debe ser resuelto</span>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 col-sm-12 col-md-12">
                <div class="input-form input-check input-check__privacidad">
                  <input type="checkbox" [(ngModel)]="politicas" id="agree" name="agree" required />
                  <label for="agree"> He leído y acepto la <a (click)="_showModalPolitica=true">política de privacidad</a> de la Oficina Virtual de {{pie}}.</label>
                </div>
                <span *ngIf="politicasError" class="error">Acepte la politica de privacidad</span>
              </div>
            </div>
            <div class="row"></div>
          </fieldset>
        </form>
      </div>
    </section>
    <div class="input-form input-button">
      <button type="submit" class="btn-default" (click)="registerUser()" value="">Enviar</button>
    </div>
  </div>
  <!-- MODAL -->
  <sacyr-modal [setTemplateRef]="modal_content" [showModal]="showModal()" (closeModal)="closeModal()"></sacyr-modal>

  <ng-template #modal_content>
    <ng-container *ngIf="_showModalPolitica">
      <h1>Política de privacidad</h1>
      <div [innerHTML]="condicionesEnvio"></div>
    </ng-container>
  </ng-template>
